import { styled, Typography } from "@mui/material";

export const StyledHeaderForm = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),
  Text: styled(Typography)({
    color: "white",
    fontWeight: "bold",
    textTransform: "upperCase",
  }),
};
